const React = require('react');
const {openPopupWindow} = require('../../../../../../../emitters/popup');
const {FormSubmitBtn, FormAdditionalBtn} = require('../../../../../FormHandlers');
const Popup = require('../../../../../Popup/C');

module.exports = ({request, title, update}) => {
  openPopupWindow((setPopupState, popup) => {
    const {close} = popup;

    const onSubmit = () => {
      setPopupState({loading: true});
      request().then(update).then(close).catch((err) => setPopupState({err: err.message, loading: false}));
    }

    return (stateOfPopup) => {
      return (
        <Popup>
          <h2 className="f23 lh34 fw7 tc">
            {title}
          </h2>
          <div className="layoutRow jcC mt60 mh-10">
            <div className="ph5">
              <FormSubmitBtn onClick={onSubmit} formCtx={{state: stateOfPopup}}>
                Delete
              </FormSubmitBtn>
            </div>
            <div className="ph5">
              <FormAdditionalBtn onClick={popup.close}>
                Cancel
              </FormAdditionalBtn>
            </div>
          </div>
        </Popup>
      )
    }
  })
}
